// Pastilles d'état des tableaux : dictionnaire FERMÉ statut → ton (crit / anor / norm).
// Seul le texte entier d'une cellule est reconnu, à la casse, aux accents et aux espaces
// près (« EN PANNE », « immobilisee ») : jamais de recherche dans une phrase, jamais de
// statut déduit d'un chiffre ou d'une date. Couleurs : jetons --ds-kpi-crit / -anor / -norm.
// Copie à l'identique dans backend/documents/statusTone.js (documents PDF, Word, Excel,
// PowerPoint) : le test backend status-tone.test.mjs vérifie que les deux fichiers sont égaux.

// Seuls des statuts au sens univoque : « Élevé » ou « Faible » (bon ou mauvais selon
// l'indicateur) n'y figurent pas. Un véhicule « En mission » est opérationnel (il compte
// dans la disponibilité) : ton normal.
export const STATUS_WORDS = {
  crit: [
    'En panne', 'Hors service', 'En retard',
    'Immobilisé', 'Immobilisée', 'Immobilisés', 'Immobilisées',
    'Accidenté', 'Accidentée', 'Accidentés', 'Accidentées',
    'Dépassé', 'Dépassée', 'Dépassés', 'Dépassées',
    'Expiré', 'Expirée', 'Expirés', 'Expirées',
    'Non conforme', 'Non conformes',
    'Critique', 'Critiques', 'Grave', 'Graves',
  ],
  anor: [
    'En maintenance', 'En attente', 'En réparation', 'En cours',
    'Urgent', 'Urgente', 'Urgents', 'Urgentes',
    'À expirer', 'À planifier', 'À fiabiliser',
    'Non traité', 'Non traitée', 'Non traités', 'Non traitées',
    'Non payé', 'Non payée', 'Non payés', 'Non payées',
    'Impayé', 'Impayée', 'Impayés', 'Impayées',
    'Attention', 'Anomalie', 'Anomalies',
  ],
  norm: [
    'Disponible', 'Disponibles', 'En service', 'En mission', 'À jour',
    'Terminé', 'Terminée', 'Terminés', 'Terminées',
    'Clôturé', 'Clôturée', 'Clôturés', 'Clôturées',
    'Payé', 'Payée', 'Payés', 'Payées',
    'Opérationnel', 'Opérationnelle', 'Opérationnels', 'Opérationnelles',
    'Actif', 'Active', 'Actifs', 'Actives',
    'Normal', 'Normale', 'Normaux', 'Normales',
    'Traité', 'Traitée', 'Traités', 'Traitées',
    'Résolu', 'Résolue', 'Résolus', 'Résolues',
    'Valide', 'Valides', 'Validé', 'Validée', 'Validés', 'Validées',
    'Conforme', 'Conformes', 'Fiable', 'Fiables', 'OK',
  ],
};

/** Texte comparé : minuscules, sans accents, apostrophe droite, espaces simples. */
export function normalizeStatus(text) {
  return String(text ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/’/g, "'")
    .replace(/[\s\u00a0\u202f]+/g, ' ')
    .trim();
}

const TONES = new Map(
  Object.entries(STATUS_WORDS).flatMap(([tone, words]) => words.map((word) => [normalizeStatus(word), tone]))
);

/** Ton d'une cellule ('crit' | 'anor' | 'norm'), ou null si son texte n'est pas un statut du dictionnaire. */
export function statusTone(text) {
  if (typeof text !== 'string' || text.length > 40) return null;
  return TONES.get(normalizeStatus(text)) ?? null;
}

export const STATUS_TONES = ['crit', 'anor', 'norm'];
